import { useQuery } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';

const HARDCODED_EXPENSES = [
  'Rent & Utilities',
  'Food & Groceries',
  'Clothing',
  'Personal Care',
  'Child Care',
  'Entertainment',
  'Healthcare',
  'Transportation',
  'Shopping',
  'Travel & Vacations',
  'Gifts & Charity',
] as const;

export type ExpenseCategory = typeof HARDCODED_EXPENSES[number] | 'Other' | 'Total';

export enum ExpenseFrequency {
  Monthly,
  Yearly,
}

export enum ExpensesMode {
  Total,
  Detailed,
}

export interface ExpenseDTO {
  Id: string;
  Name: string;
  Amount: number;
  Frequency: ExpenseFrequency | null;
  Year: number | null;
  RepeatEveryNYears: number | null;
  RepeatForNYears: number | null;
  ExpenseOrigin: 'PulseCheck' | null;
  Cadence: string;
  RecurringAmount: number;
}

export interface ExpensesDTO {
  HardCodedExpenseNames: typeof HARDCODED_EXPENSES;
  Frequencies: { value: ExpenseFrequency; label: string }[];
  YearsOptions: number[];
  CanEstimate: boolean;
  MortgageMonthlyTotal: number;
  LoanMonthlyTotal: number;
  InsuranceMonthlyTotal: number;
  ExpensesInputMode: ExpensesMode;
  TotalExpenses: ExpenseDTO;
  DetailedExpenses: ExpenseDTO[];
  Hint: string;
}

interface FetchParams {
  clientId: string;
}

const fetchExpenses = async ({ clientId }: FetchParams): Promise<ExpensesDTO> => {
  return authFetch(urlWithParams('/Consumer/Expenses', { clientId }));
};

interface QueryParams {
  clientId: string;
}

export const useExpensesQuery = ({ clientId }: QueryParams) => {
  return useQuery(
    queryKeys.expenses(clientId),

    () => fetchExpenses({ clientId }),

    {
      cacheTime: 0,
    },
  );
};
